/**
 * sessionStorage keys for the Cognito flow. PKCE/state/nonce live here so they survive
 * the redirect to the Hosted UI and are available on the callback.
 */
export const STORAGE_KEYS = {
  // PKCE / CSRF / nonce values for the authorization request.
  CODE_VERIFIER: 'cognito_code_verifier',
  STATE: 'cognito_state',
  NONCE: 'cognito_nonce',

  // Session tokens and derived claims established on the callback.
  ID_TOKEN: 'cognito_id_token',
  ACCESS_TOKEN: 'cognito_access_token',
  REFRESH_TOKEN: 'cognito_refresh_token',
  EXPIRES_AT: 'cognito_expires_at',
  USER_SUB: 'cognito_user_sub',
  USER_EMAIL: 'cognito_user_email',
};

export default STORAGE_KEYS;
